import FMCalendarComponent from './Calender';


const FMCalendar = ({
  conversation,
  options,
  message,
  rows,
  messageType,
  parentTabId,
  inContainer,
  parentDocId,
}) => {

  const parentDocIdkey = parentDocId || options?.parentDocId
  return (
    <FMCalendarComponent
      options={options}
      message={message || rows}
      conversation={conversation}
      messageType={messageType}
      parentTabId={parentTabId}
      parentDocId={parentDocIdkey}
      inContainer={inContainer}
    />
  );
};

export default FMCalendar;
